/* tutor-1 (C): EL MENSAJE DEL ALUMNO: burbuja a la derecha (#1B1B1B, borde #2C2C2C, esquinas 18 con la de abajo a la
   derecha en 6, 15 px). Si llevo fotos, van arriba como miniaturas de 64: las recien mandadas desde su `blob:` local;
   las guardadas, servidas por `GET /tutor/fotos/{msg}/{n}` (en la app, pedidas con la cabecera de la sesion).

   ARCHIVO EN ASCII A PROPOSITO. */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cargarImagen, urlDeFoto } from '../../lib/tutor';

function Miniatura({ src, etiqueta }) {
  return (
    <span className="w-16 h-16 rounded-[10px] overflow-hidden border border-[#2C2C2C] bg-[#171717] block" data-testid="tutor-miniatura">
      {src ? <img src={src} alt={etiqueta} className="w-full h-full object-cover" /> : null}
    </span>
  );
}

function FotoGuardada({ msgId, n, etiqueta }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let vivo = true;
    let blob = null;
    cargarImagen(urlDeFoto(msgId, n)).then((u) => {
      if (u && u.startsWith('blob:')) blob = u;
      if (vivo) setSrc(u);
    }).catch(() => {});
    return () => {
      vivo = false;
      if (blob) { try { URL.revokeObjectURL(blob); } catch (e) { /* nada */ } }
    };
  }, [msgId, n]);
  return <Miniatura src={src} etiqueta={etiqueta} />;
}

export default function MensajeAlumno({ mensaje }) {
  const { t } = useTranslation('study');
  const locales = mensaje.fotosLocales || [];
  const guardadas = locales.length ? 0 : Number(mensaje.fotos || 0);
  return (
    <div className="self-end max-w-[86%] md:max-w-[78%] rounded-[18px] rounded-br-[6px] bg-[#1B1B1B] border border-[#2C2C2C] px-[15px] py-[11px] text-[15px] leading-[1.5] text-[#F4F4F3] whitespace-pre-wrap break-words"
      data-testid="tutor-mensaje-alumno">
      {locales.length || guardadas ? (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {locales.map((u, i) => <Miniatura key={u} src={u} etiqueta={t('tutor.photos.label', { n: i + 1 })} />)}
          {Array.from({ length: guardadas }, (_, i) => (
            <FotoGuardada key={i} msgId={mensaje.id} n={i + 1} etiqueta={t('tutor.photos.label', { n: i + 1 })} />
          ))}
        </div>
      ) : null}
      {mensaje.texto}
    </div>
  );
}
